import React from 'react';
import styled, { css } from 'styled-components';

const TextWrapper = styled.p`
    margin: 0px;
    &.clickable {
        cursor: pointer;
    }
    /* Color based on theme */
    ${(props) =>
        props.theme === 'default' &&
        css`
            color: var(--color-bw_black);
        `};
    ${(props) =>
        props.theme === 'primary' &&
        css`
            color: var(--color-primary_fireenginered);
        `};
    ${(props) =>
        props.theme === 'support' &&
        css`
            color: var(--color-secondary_darktan);
        `};
    ${(props) =>
        props.theme === 'help' &&
        css`
            color: var(--color-davysgrey);
        `};
    ${(props) =>
        props.theme === 'error' &&
        css`
            color: var(--color-support_goldengatebridge);
        `};
    ${(props) =>
        props.theme === 'success' &&
        css`
            color: var(--color-support_salem);
        `};

    /* Font Size based on 'size' */
    ${(props) =>
        props.size === 'h1' &&
        css`
            font-size: 3.5em;
        `};
    ${(props) =>
        props.size === 'h2' &&
        css`
            font-size: 2.5em;
        `};
    ${(props) =>
        props.size === 'h3' &&
        css`
            font-size: 2em;
        `};
    ${(props) =>
        props.size === 'h4' &&
        css`
            font-size: 1.75em;
        `};
    ${(props) =>
        props.size === 'h5' &&
        css`
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 5px;
            color: #CB4334;
        `};
    ${(props) =>
        props.size === 'h6' &&
        css`
            font-size: 14px;
        `};
    ${(props) =>
        props.size === 'h7' &&
        css`
            font-size: 1em;
        `};

    /* Font Size based on 'size' */
    ${(props) =>
        props.font_style === 'normal' &&
        css`
            font-style: normal;
        `};
    ${(props) =>
        props.font_style === 'italic' &&
        css`
            font-style: italic;
        `};
    ${(props) =>
        props.font_style === 'bold' &&
        css`
            font-weight: bold;
        `};
    ${(props) =>
        props.font_style === 'bolditalic' &&
        css`
            font-style: italic;
            font-weight: bold;
        `};
`;

const Text = ({
    id = '',
    class_name = '',
    text = 'Text',
    size = 'h4',
    font_style = 'normal',
    theme = 'default', // Default, Support, Error, Success, Help
    text_styles = undefined,
    clickable = false,
    clickable_method = undefined,
    ...props
}) => {
    if (clickable) {
        return (
            <TextWrapper
                className={`clickable ${class_name}`}
                id={id}
                onClick={clickable_method}
                size={size}
                style={text_styles}
                font_style={font_style}
                theme={theme}
            >
                {props.children}
            </TextWrapper>
        );
    } else {
        return (
            <TextWrapper
                className={class_name}
                id={id}
                size={size}
                style={text_styles}
                font_style={font_style}
                theme={theme}
            >
                {text}
            </TextWrapper>
        );
    }
};
export default Text;
